import { SharedDocument } from 'types/Document';
import { StateSetter } from 'types/utils/React';

export const isDocumentSelected = (
  document: SharedDocument,
  documentsToDelete: SharedDocument[],
): boolean => !!documentsToDelete.find((_) => _.id === document.id);

export type GetDocumentItemSelectFunctionInputType = {
  document: SharedDocument;
  documentsToDelete: SharedDocument[];
  isDeleteMode: boolean;
  setDocumentsToDelete: StateSetter<SharedDocument[]>;
};

export const getDocumentItemSelectFunction =
  ({
    document,
    documentsToDelete,
    isDeleteMode,
    setDocumentsToDelete,
  }: GetDocumentItemSelectFunctionInputType) =>
  (): void => {
    if (isDeleteMode) {
      const selected = isDocumentSelected(document, documentsToDelete);

      if (selected) {
        const updatedDocumentsToDelete = documentsToDelete.filter(
          (_) => _.id !== document.id,
        );
        setDocumentsToDelete(updatedDocumentsToDelete);
      } else {
        setDocumentsToDelete([...documentsToDelete, document]);
      }
    }
  };
